export const msalConfig = {
  cache: {
    cacheLocation: "localStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const scopes = {
  scopes: ["User.Read", "Sites.Read.All", "Sites.ReadWrite.All", "Files.ReadWrite.All"],
  forceRefresh: false, // Set this to "true" to skip a cached token and go to the server to get a new token
};
